import { EImageType, IOffer, ITypedImage } from '../../types/offer';

const DEFAULT_VALUE: ITypedImage = { type: EImageType.Normal, url: '', thumbnailUrl: '' };

export function getFirstImageFromOffer(offer: IOffer): ITypedImage {
  const { images = [] } = offer;

  return images[0] || DEFAULT_VALUE;
}
